import {
  Alert,
  Avatar,
  AvatarFallback,
  AvatarImage,
  Dialog,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
} from '@sr/ui-library';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MEMBERSHIP_AGREEMENT_URL } from '../../constant/Common';
import { userService } from '../../reducers/permissions/userSlice';
import { useTypedSelector } from '../../stateStore';
import { userInitials, userIsInCustomerView } from '../../utils/helpers/common';
import { NotificationsNavGate } from '../navigation/NotificationsNavGate';

const UserProfileMini = () => {
  const navigate = useNavigate();
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);

  const userMe = useTypedSelector(userService.selectors.userMe);

  if (!userMe) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="btn-circle flex h-[50px] w-full items-center gap-1.5 p-[4px] hover:btn-accent">
          <Avatar className="h-10 w-10">
            <AvatarImage src={userMe.imageUri} />
            <AvatarFallback>
              {userInitials(userMe.firstName + ' ' + userMe.lastName)}
            </AvatarFallback>
          </Avatar>

          <span className="sr-only">{userMe?.firstName}&rsquo;s profile</span>
          <Icon className="text-sr-white" icon="chevronDown" />
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
          <DropdownMenuItem asChild>
            <Link to="/profile/my-profile">My Profile</Link>
          </DropdownMenuItem>
          <NotificationsNavGate>
            <DropdownMenuItem asChild>
              <Link to="/profile/notifications">Notifications</Link>
            </DropdownMenuItem>
          </NotificationsNavGate>

          <DropdownMenuSeparator />

          <DropdownMenuItem asChild>
            <Link
              rel="noopener noreferrer"
              target="_blank"
              to="https://knowledge.screenrights.org/en"
            >
              Help
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link rel="noopener noreferrer" target="_blank" to="/terms">
              Terms and Conditions
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              rel="noopener noreferrer"
              target="_blank"
              to={MEMBERSHIP_AGREEMENT_URL}
            >
              Membership Agreement
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="font-medium"
            onClick={() => setIsLogOutModalOpen(true)}
          >
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog
        heading="Are you sure you want to log out?"
        actionButtonProps={{
          children: 'Log out',
          onClick: () => navigate('/logout'),
        }}
        cancelButtonProps={{
          children: 'Cancel',
          onClick: () => setIsLogOutModalOpen(false),
        }}
        open={isLogOutModalOpen}
        onOpenChange={() => setIsLogOutModalOpen(false)}
      >
        {userIsInCustomerView(userMe) && (
          <Alert
            actionButtonProps={{
              children: 'Close customer view',
              onClick: () => window.close(),
            }}
            className="my-4 w-auto"
            hasActionButton
            variant="warning"
          >
            Hi <strong>{userMe?.firstName}</strong>. If you would like to close
            customer view while staying logged in to Service Central, click the
            close button below (instead of log out).
          </Alert>
        )}
      </Dialog>
    </>
  );
};

export default UserProfileMini;
